import React from "react";
import { inject, observer } from "mobx-react";
import { Checkbox, FormColumn4Wide, TableTitle } from "best-common-react";
import OrgSeasonAddOnContainer from "./OrgSeasonAddOnContainer";

function OrgAddOnBody(props) {
  const { commonStore, orgAdminStore } = props.rootStore;

  return (
    <div>
      <TableTitle>Ticket Add Ons</TableTitle>
      <FormColumn4Wide className="mt-4">
        <Checkbox
          checked={orgAdminStore.isOrgEnabled}
          label="Enable Ticket Add-Ons"
          onChange={orgAdminStore.toggleIsOrgEnabled}
        />
      </FormColumn4Wide>
      {orgAdminStore.currentSeasons?.map(curr => {
        return orgAdminStore.isOrgEnabled ? (
          <OrgSeasonAddOnContainer season={curr} org={commonStore.currentOrgId} />
        ) : null;
      })}
    </div>
  );
}

export default inject("rootStore")(observer(OrgAddOnBody));
